module.exports = __webpack_public_path__ + "static/img/004.2a615c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/004.png
// module id = /gCr
// module chunks = 1